// frontend/src/hooks/useDateRange.js

import { useState, useEffect } from 'react';
import dayjs from 'dayjs';

const useDateRange = (data, options = {}) => {
    const { dateColumn = 'Date', defaultPeriod = '10Y' } = options;

    const [minDate, setMinDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [viewStartDate, setViewStartDate] = useState(null);
    const [viewEndDate, setViewEndDate] = useState(null);
    const [activePeriod, setActivePeriod] = useState(null); 

    const calculateStartDate = (period, baseDate, firstDate) => {
        const newStartDate = dayjs(baseDate);
        
        if (period === 'ALL') {
            return dayjs(firstDate);
        }
        if (period === 'YTD') {
            return newStartDate.startOf('year');
        }

        const unit = period.slice(-1).toUpperCase();
        const value = parseInt(period.slice(0, -1), 10);

        if (isNaN(value)) return dayjs(firstDate);

        if (unit === 'Y') {
            return newStartDate.subtract(value, 'year');
        } else if (unit === 'M') {
            return newStartDate.subtract(value, 'month');
        }
        
        return dayjs(firstDate);
    };

    useEffect(() => {
        if (data && data.length > 0) {
            const dates = data.map(d => new Date(d[dateColumn]));
            const firstDate = new Date(Math.min(...dates));
            const lastDate = new Date(Math.max(...dates));

            setMinDate(firstDate);
            setMaxDate(lastDate);

            const newStartDate = calculateStartDate(defaultPeriod, lastDate, firstDate);
            
            setViewStartDate(newStartDate.isBefore(dayjs(firstDate)) ? firstDate : newStartDate.toDate());
            setViewEndDate(lastDate);
            setActivePeriod(defaultPeriod);
        }
    }, [data, dateColumn, defaultPeriod]);
    
    // 제거된 로직: 날짜 상태 변경에 따른 활성 버튼 동적 감지 로직

    const handlePeriodChange = (period) => {
        if (!maxDate || !minDate) return;

        const newStartDate = calculateStartDate(period, maxDate, minDate);
        
        setViewStartDate(newStartDate.isBefore(dayjs(minDate)) ? minDate : newStartDate.toDate());
        setViewEndDate(maxDate);
        // 버튼 클릭 시에만 활성 상태를 업데이트
        setActivePeriod(period);
    };

    const handleDateChange = (type, date) => {
        if (type === 'start') {
            const newStartDate = date > viewEndDate ? viewEndDate : date;
            setViewStartDate(newStartDate);
        } else {
            const newEndDate = date < viewStartDate ? viewStartDate : date;
            setViewEndDate(newEndDate);
        }
        // 날짜 선택기를 사용해도 활성 상태를 변경하지 않음
    };

    return {
        minDate,
        maxDate,
        viewStartDate,
        viewEndDate,
        handlePeriodChange,
        handleDateChange,
        activePeriod,
        isDateReady: !!viewStartDate,
    };
};

export default useDateRange;